/**
 *
 * MyWort Search for Header
 */


module.exports = {

  componentClassName: '.mywort-header-search',
  componentOpenTriggerClassName: '.js-search-trigger--open',
  componentCloseTriggerClassName: '.js-search-trigger--close',
  componentToggleClassName: 'mywort-header-search--expanded',
  headerParentClassName: 'mywort-header',
  headerParentFixedClassName: 'mywort-header--fixed',
  scrollableSelector: '.Select-menu',
  animationTime: 600,

  isDescendant: function(parent, child) {
    var node = child.parentNode;
    while (node !== null) {
      if (node === parent) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  },

  // As Soon as user touches outside of Scroll Area, we call onBlur to close Search
  _windowTouchStart: function(ev){
    var parent = $(this.componentClassName)[0];
    if(this.isDescendant(parent, ev.target)){
      var select = document.getElementById('mywort-header-search-mount');
      if(!this.isDescendant(select, ev.target)){
        ev.stopPropagation();
      }
      return;
    }

    window.removeEventListener('touchstart', this.windowTouchStart, true);
    $(parent).find('input').blur();
  },

  _documentTouchMove: function(ev){
    ev.preventDefault();
  },

  _bodyTouchStart: function(ev){
    if (ev.currentTarget.scrollTop === 0) {
      ev.currentTarget.scrollTop = 1;
    } else if (ev.currentTarget.scrollHeight === ev.currentTarget.scrollTop + ev.currentTarget.offsetHeight) {
      ev.currentTarget.scrollTop -= 1;
    }
  },

  _bodyTouchEnd: function(ev){
    ev.stopPropagation();
  },

  _bodyTouchMove: function(ev){
    ev.stopPropagation();
  },

  _positionHeaderAbsolute: function($header){
    if(!$header.hasClass(this.headerParentFixedClassName)){
      $header.css('position', '').css('top', '').css('transform','');
      return;
    }
    var doc = document.documentElement;
    var top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
    let lwHeader = $("#mobile-top-bar").height();
    top = top<lwHeader ? lwHeader:top; // we set a min "top" to always be under the LW header
    $header.css('position', 'absolute').css('top', top+'px');//.css('transform', 'none');
  },

  openFullScreenSearch: function($container){
    // Open and Expand Search Header
    let $header = $container.parents('.' + this.headerParentClassName);
    $container.addClass(this.componentToggleClassName);
    var $input = $container.find('input');

    $input.focus().trigger('mousedown').trigger('keydown');
    $('.mywort-header__center').addClass('u-stretch-100vh');
    $('.mywort-header__center').css('position', 'absolute').css('transform','none');

    if(!$header.hasClass(this.headerParentFixedClassName)){
      $header.addClass(this.headerParentFixedClassName);
    }
  },

  mountFullScreenSearchListeners: function(){
    // Adding listeners on touch actions to prevent Overscroll on ios, as described here
    // http://stackoverflow.com/questions/10238084/ios-safari-how-to-disable-overscroll-but-allow-scrollable-divs-to-scroll-norma
    var selScrollable = this.scrollableSelector;
    this.documentTouchMove = this._documentTouchMove.bind(this);
    $(document).on('touchmove', this.documentTouchMove);

    this.bodyTouchStart = this._bodyTouchStart.bind(this);
    $('body').on('touchstart', selScrollable, this.bodyTouchStart);

    this.bodyTouchEnd = this._bodyTouchEnd.bind(this);
    $('body').on('touchend', selScrollable, this.bodyTouchEnd);

    this.bodyTouchMove = this._bodyTouchMove.bind(this);
    $('body').on('touchmove', selScrollable, this.bodyTouchMove);
  },

  unMountFullScreenSearch: function(){
    // Remove Event Listeners on touch body and document
    var selScrollable = this.scrollableSelector;
    $(document).off('touchmove', this.documentTouchMove);
    $('body').off('touchstart', selScrollable, this.bodyTouchStart);
    $('body').off('touchend', selScrollable, this.bodyTouchEnd);
    $('body').off('touchmove', selScrollable, this.bodyTouchMove);
    window.removeEventListener('touchstart', this.scroller, true);
    clearInterval(this.interval);
  },

  closeFullScreenSearch: function($container){

    // Close Seach Header && reset attributes
    $container.removeClass(this.componentToggleClassName);
    let $header = $container.parents('.' + this.headerParentClassName);
    $('.mywort-header__center').removeClass('u-stretch-100vh');
    $header.css('position', '').css('top', '').css('transform','');
    $('.mywort-header__center').css('position', '').css('top', '').css('transform','');
    $('#mywort-header-duply').remove();
  },

  init: function () {
    let that = this;

    $(that.componentClassName).each(function () {
      let $container = $(this);
      // Execute only on event firing from react component when fully mounted
      window.addEventListener('search-mount', function(){
        $container.click(function(){
          $container.find('input').get(0).focus();
        });
        $container.find('input').each(function(){
          $( this ).attr( 'autocomplete', 'off' ).attr('autocapitalize', 'off').attr('spellcheck', 'false').attr('autocorrect', 'off');
          $(this).focus(function(){
            that.windowTouchStart = that._windowTouchStart.bind(that);
            window.addEventListener('touchstart', that.windowTouchStart, true);
            that.mountFullScreenSearchListeners();
            let $header = $container.parents('.' + this.headerParentClassName);
            if($header.hasClass(that.headerParentFixedClassName)){
              var doc = document.documentElement;
              var top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
              window.scrollTo(0,top);
              return;
            }

            // Reposition Header if scrolling happens on Page
            that._positionHeaderAbsolute($header);
            that.interval = setInterval( function(){
              let _$header = $container.parents('.' + that.headerParentClassName);
              that._positionHeaderAbsolute(_$header);
            }, 150);
          });

          $(this).blur(function(){
            that.unMountFullScreenSearch();
            var event = document.createEvent('Event');
            event.initEvent('search-close', true, true);
            $container.get(0).dispatchEvent(event);

          })
        });
      });

      // Add listener to open Search on Phones
      $container.find(that.componentOpenTriggerClassName).each(function(){
        $(this).click(function(){
          that.openFullScreenSearch($container);
        })
      });

      // Search close event might come from onBlur, or another touch event
      $container.get(0).addEventListener('search-close', function(){
        that.closeFullScreenSearch($container);
      })

    });
  }
};



// WEBPACK FOOTER //
// ./js/mywort/styleguide/search.js